import React from 'react';
import { styled } from '@linaria/react';
import { useTheme } from 'src/theme';

const rightRequired = 6;

const Container = styled.div<StyledProps>`
  display: block;
  margin: ${props => props.margin ? (typeof props.margin === 'number' ? `${props.margin}px` : props.margin) : '0'};
`

const StepsBlock = styled.div<StyledProps>`
  display: flex;
  justify-content: space-between;
`

const Step = styled.div<StyledProps>`
  height: 5px;
  background: ${props => props.fill ? props.theme.colors.primary: props.theme.colors.grey[600]};
  width: 100%;
  box-sizing: content-box;
  &:not(:last-child) {
    margin-right: ${rightRequired}px;
  }
`
const Label = styled.p<StyledProps>`
  text-align: left;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => props.theme.fontSize.text}px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${props =>  props.theme.colors.grey[500]};
  margin-bottom: 20px;
`

const CurrentStep = styled.span<StyledProps>`
  font-weight: bold;
`
interface StyledProps {
  theme?: any;
  fill?: number;
  steps?: number;
  margin?: string | number | undefined;
}

export interface MultiStepsProps {
  steps: number;
  step: number;
  label: string;
  theme?: any;
  margin: string | number;
}


function MultiSteps({ label, step, steps, margin }: MultiStepsProps) {
  const theme = useTheme();
  const array = [];
  for (let index = 0; index < steps; index++) {
    const fill: boolean = (index + 1 <= step);
    array.push(<Step key={`key-${index}`} steps={steps} theme={theme} fill={fill ? 1 : 0}></Step>)
  }
  return <Container margin={margin}>
    <Label theme={theme}> {label} <CurrentStep theme={theme}> Step {step} of {steps} </CurrentStep> </Label>
    <StepsBlock>
      {array}
    </StepsBlock>
  </Container>;
};

MultiSteps.defaultProps = {
  steps: 1,
  step: 0,
  label: '',
  margin: '0 0 30px',
}

export default MultiSteps;
